// AUTH ACTIONS
export const LOGIN = "LOGIN";
export const LOGOUT = "LOGOUT";
export const UPDATE_PROFILE = "UPDATE_PROFILE";

// FEEDBACK ACTIONS
export const NOTIFY = "NOTIFY";
